<template>
  <div
    class="journal-filters"
    :class="{ 'back-button-top': backButton }"
  >
    <div
      v-if="backButton"
      class="container"
    >
      <nuxt-link
        class="back-button"
        to="/journal"
      >
        <ArrowLeft />
        back to the journal
      </nuxt-link>
    </div>
    <div
      v-else
      class="container"
    >
      <nuxt-link
        to="/journal"
        :class="{ active: !activeCategory }"
        @click.prevent="setCategory(null)"
      >
        All
      </nuxt-link>
      <nuxt-link
        :to="`/journal?category=${DEFAULT_CATEGORIES.DEV_SUCCESS_CATEGORY}`"
        :class="{
          active: activeCategory === DEFAULT_CATEGORIES.DEV_SUCCESS_CATEGORY,
        }"
        @click.prevent="setCategory(DEFAULT_CATEGORIES.DEV_SUCCESS_CATEGORY)"
      >
        Developer success
      </nuxt-link>
      <nuxt-link
        v-for="(category, index) in categories"
        :key="index"
        :to="`/journal?category=${category.slug}`"
        :class="{ active: activeCategory === category.slug }"
        @click.prevent="setCategory(category.slug)"
      >
        {{ category.title }}
      </nuxt-link>
      <nuxt-link
        :to="`/journal?category=${DEFAULT_CATEGORIES.DEV_DOWNLOADS_CATEGORY}`"
        :class="{
          active: activeCategory === DEFAULT_CATEGORIES.DEV_DOWNLOADS_CATEGORY,
        }"
        @click.prevent="setCategory(DEFAULT_CATEGORIES.DEV_DOWNLOADS_CATEGORY)"
      >
        Dev Downloads
      </nuxt-link>
    </div>
  </div>
</template>

<script>
import ArrowLeft from '~/components/Common/Svg/ArrowLeft.vue';
import { useJournalStore, DEFAULT_CATEGORIES } from '~/stores/journal';
export default {
  components: { ArrowLeft },
  props: {
    backButton: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      journalStore: useJournalStore(),
      DEFAULT_CATEGORIES,
    };
  },
  computed: {
    categories() {
      return this.journalStore?.categories;
    },
    activeCategory() {
      return this.journalStore?.category;
    },
  },
  methods: {
    setCategory(category = null) {
      this.journalStore.setCategory(category);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './JournalFilters.scss';
</style>
